import { TextField } from '@mui/material';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useField } from 'informed';

export default function DateTimeInput(props) {
  const { fieldState, fieldApi, render, ref, userProps } = useField(props);

  const { value } = fieldState;
  const { setValue, setTouched } = fieldApi;
  const { onChange, onBlur, label, size, ...rest } = userProps;

  return render(
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DateTimePicker
        ampm={false}
        inputFormat="yyyy/MM/dd HH:mm"
        renderInput={(props) => <TextField
          {...props}
          margin="dense"
          error={Boolean(fieldState.error)}
          helperText={fieldState.error || " "}
          size={size}
        />}
        label={label}
        {...rest}
        ref={ref}
        value={!value && value !== 0 ? '' : value}
        onChange={newValue => {
          setValue(newValue);
          if (onChange) {
            onChange(newValue);
          }
        }}
        onBlur={e => {
          setTouched(true);
          if (onBlur) {
            onBlur(e);
          }
        }}
      />
    </LocalizationProvider>
  );
}
